import { render, staticRenderFns } from "./RecordForm.vue?vue&type=template&id=113d3afe&"
import script from "./RecordForm.vue?vue&type=script&lang=ts&"
export * from "./RecordForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports